import { IProps, IUserConsumers, IUserState } from "./type";
import {
  createContext,
  memo,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import WelcomeLoader from "@components/welcomeLoader";
import { getMe as getProfile } from "@network/account/getMe";

const UserContext = createContext<any>(null);

const UserProvider = memo((props: IProps) => {
  const [ready, setReady] = useState<boolean>(false);
  const [state, setState] = useState<IUserState | null>(null);

  const getProfileData = useCallback(() => {
    return getProfile()
      .then((res) => {
        setState(res);
        if (window.posthog) {
          window.posthog.identify(res.username, {
            email: res.email,
            name: res.first_name,
            role: res.user_type,
          });
        }
        return res;
      })
      .finally(() => {
        setReady(true);
      })
      .catch((err) => {
        setState((prev) => null);
        setReady(true);
        return null;
      });
  }, []);

  useEffect(() => {
    if (!window.location.pathname.includes("auth")) {
      getProfileData();
    } else {
      setReady(true);
    }
  }, [getProfileData]);

  if (ready)
    return (
      <UserContext.Provider
        value={{ ...state, updateUserProfile: getProfileData }}
      >
        {props.children}
      </UserContext.Provider>
    );
  else return <WelcomeLoader />;
});

export const useUserContext = (): IUserConsumers => useContext(UserContext);

export { UserProvider };
